import { render, staticRenderFns } from "./ai-test-images.vue?vue&type=template&id=97843862&scoped=true"
import script from "./ai-test-images.vue?vue&type=script&lang=js"
export * from "./ai-test-images.vue?vue&type=script&lang=js"
import style0 from "./ai-test-images.vue?vue&type=style&index=0&id=97843862&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97843862",
  null
  
)

export default component.exports